import { FC } from 'react';

import { Help } from '../partials/Help';
import { InfoDialog } from './InfoDialog';

type Props = {
  open: boolean
  onClose: () => void
}

export const HelpDialog: FC<Props> = ({ open, onClose }) => {
  return (
    <InfoDialog id="help-dialog" title="We're here if you need us" open={open} onClose={onClose}>
      <Help />
    </InfoDialog>
  );
};
